export default __webpack_public_path__ + "static/media/TypesMetalCastingImg.fbbeb26b.png";